var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { I18nextProvider } from 'react-i18next';
import '../../const/iconLibrary';
import { ThemeProvider } from 'styled-components';
import RewardsPageContextProvider from './context/rewardsPageContext';
import PageWrapper from './subcomponents';
import RewardDetails from './ui/templates/RewardDetails';
import RewardsConfigContextProvider from '../../context/rewardsConfig';
import rewardsI18n from '../../strings/i18n';
import ErrorBoundary from '../../ui/templates/ErrorBoundary';
import ErrorPage from '../../ui/templates/ErrorPage';
import theme from '../../ui/theme';
import useSelectedClientId from '../../hooks/useSelectedClientId';
var RewardsPage = function (_a) {
    var config = _a.config;
    var clientId = useSelectedClientId(config);
    useEffect(function () {
        rewardsI18n.changeLanguage(config.lang);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [config.lang]);
    return (_jsx(PageWrapper, { children: _jsx(I18nextProvider, __assign({ i18n: rewardsI18n }, { children: _jsx(ThemeProvider, __assign({ theme: theme }, { children: _jsx(RewardsConfigContextProvider, __assign({ state: { config: config } }, { children: _jsx(RewardsPageContextProvider, { children: _jsx(ErrorBoundary, __assign({ customFallback: _jsx(ErrorPage, { config: config, analyticsEventOptions: {
                                    clientName: clientId
                                }, className: "rewards-page" }) }, { children: _jsx(RewardDetails, {}) })) }) })) })) })) }));
};
export default RewardsPage;
